import { useState, useEffect } from 'react';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-contact';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      '@id': `${import.meta.env.VITE_SITE_URL ?? ''}/contact#webpage`,
      url: `${import.meta.env.VITE_SITE_URL ?? ''}/contact`,
      name: 'Contact - 글로벌 이름 테스트 문의',
      description: '글로벌 이름 테스트 서비스에 대한 문의사항을 남겨주세요.',
      inLanguage: 'ko',
      isPartOf: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? ''}/#website`,
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '홈', item: import.meta.env.VITE_SITE_URL ?? '' },
          { '@type': 'ListItem', position: 2, name: 'Contact', item: `${import.meta.env.VITE_SITE_URL ?? ''}/contact` },
        ],
      },
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById('schema-contact')?.remove();
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      await fetch('https://readdy.ai/api/form/d6gleu2u8ojn6g516gkg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <div className="max-w-2xl mx-auto px-4 py-16">
        <a href="/" className="inline-flex items-center gap-2 text-purple-500 hover:text-purple-700 mb-10 cursor-pointer transition-colors">
          <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
          <span className="text-sm font-medium">홈으로 돌아가기</span>
        </a>

        <div className="bg-white rounded-3xl shadow-xl p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Contact</h1>
          <div className="w-12 h-1 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-8"></div>

          <div className="space-y-4 text-gray-600 mb-10">
            <p>문의사항이 있으시면 아래 이메일로 연락주세요.</p>
            <a
              href="mailto:naholoceo12@naver.com"
              className="inline-flex items-center gap-2 text-purple-600 font-semibold hover:text-purple-800 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
              naholoceo12@naver.com
            </a>
          </div>

          <div className="border-t border-gray-100 pt-8">
            <p className="text-sm font-semibold text-gray-700 mb-6">또는 아래 양식으로 문의해주세요</p>

            {submitted ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
                </div>
                <p className="text-gray-700 font-medium">문의가 접수되었습니다. 감사합니다!</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">이름</label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="홍길동"
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-purple-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">이메일</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="example@email.com"
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-purple-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">문의 내용</label>
                  <textarea
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    placeholder="문의 내용을 입력해주세요. (최대 500자)"
                    className="w-full px-4 py-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-purple-400 transition-colors resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-3.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-xl hover:shadow-lg hover:scale-[1.02] transition-all whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100"
                >
                  {isSubmitting ? '전송 중...' : '문의 보내기'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
